import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { createGlobalStyle } from 'styled-components';
const GlobalStyles = createGlobalStyle `
  .article-layout {
    background: var(--bgColor);
    color: var(--fgColor);
    padding-bottom: ${fluid(48, 96)};
    position: relative;

    &--dark {
      --bgColor: ${brand.black};
      --fgColor: ${brand.white};
    }

    &--light {
      --bgColor: ${brand.white};
      --fgColor: ${brand.black};
    }

    &__inner {
      ${siteWide}
      ${baseGrid}

      position: relative;
      z-index: 2;
    }
    
    &__content {
      max-width: 713px;
    }

    &__aside {
      max-width: 625px;
    }
    
    @media ${until(Device.Desktop)} {
      &__content {
        grid-column: 1 / span 12;
      }

      &__aside {
        grid-column: 1 / span 12;
      }
    }

    @media ${from(Device.Desktop)} {
      &__content {
        grid-column: 2 / span 5;
      }

      &__aside {
        grid-column: -6 / span 5;
      }
    }
  }

  .article-logo-overlay {
    @media ${from(Device.TabletLarge)} {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: ${brand.black};
      background: linear-gradient(
        to bottom, 
        transparent 0%, 
        ${brand.black} 600px, 
        ${brand.black} 100%
      );
      opacity: 0.77;
    }
  }
`;
const ArticleGlobalStylesStyles = {
    GlobalStyles,
};
export default ArticleGlobalStylesStyles;
